<template>
  <div class="thousand_layout">
    <div class="chp_box">
      <div class="chp_index">
        <div class="chp_index_box">
          <div>{{ $t('base.balanceNow') }}</div>
          <div class="chp_num">{{userInfo.SumMoney}}</div>
          <div class="chp_change">
            <div>
              <router-link v-if="userInfo.VerifyStatus==2" class="chp_btn" :to="{path:'/pay/chp'}">{{ $t('title.charge') }}</router-link>
              <span v-if="noNew" class="chp_btn" @click="showRefund(true)">{{ $t('base.Refund') }}</span>
            </div>
            <div class="What_c">
              <span></span>
              <router-link :to="{path:'/terms/privacy?type=3'}">{{ $t('symbol.whatCHP') }}</router-link>
            </div>
          </div>
        </div>
      </div>
      <template v-if="noNew">
        <el-dialog title="Enter refund info" :visible.sync="isRefund" custom-class="dialogBox" :lock-scroll="false">
          <div>
            <!-- <el-alert :title="$t('chp.violations')" type="error" show-icon :closable="false"></el-alert> -->
            <div class="refundDialogBox">
              <div class="Refundable">
                <div class="refundableCHP">
                  <div class="chp">{{$t('base.Refundable')}}:<span>{{userInfo.RefundCHP}}</span></div>
                  <div class="text_gray">{{$t('base.NonRefundable')}}:{{userInfo.GiveCHP}} {{$t('chp.nonrefundable')}}</div>
                </div>
              </div>
              <el-form :model="refundForm" :rules="rules" ref="refundForm">
                <el-form-item prop="chp">
                <div>CHP</div>
                  <el-input v-model="refundForm.chp" size="medium" :placeholder="$t('chp.youwantreturn')" @input="refundForm.chp = refundForm.chp.replace(/[^\d.]/g, '')"></el-input>
                </el-form-item>
                <el-form-item prop="paypal">
                <div>PayPal</div>
                  <el-input v-model="refundForm.paypal" :placeholder="$t('chp.yourPayPalaccount')" size="medium"></el-input>
                </el-form-item>
              </el-form>
              <div class="text_gray small_text">{{$t('chp.provideyourPayPal')}}</div>
              <div class="alert_divider"></div>
              <div class="text_gray small_text">{{$t('chp.takeupbusinessdays')}}</div>
              
              <div slot="footer" class="dialog-footer" style="text-align: right;margin-top: 60px;">
                <el-button  @click="isRefund=false">{{$t('base.cancel')}}</el-button>
                <el-button type="primary" @click="submitRefund" >{{ $t('base.Submit') }}</el-button>
              </div>
            </div>
          </div>
        </el-dialog>
      </template>
      <div class="chp_list_box">
        <h4 class="chp_h4">{{ $t('base.chpHistory') }}</h4>
        <div v-if="noNew">
          <div class="chp_tab">
            <div :class="{'active':(chpTab==0)}" @click="chpTab=0">{{$t('base.chpHistory')}}</div>
            <div :class="{'active':(chpTab==1)}" @click="chpTab=1">{{$t('chp.RefundHistory')}}</div>
          </div>
          <div class="refund_tab">
            <template v-if="chpTab==1">
              <div :class="{'active':(refundType==1)}" @click="refundType=1">{{$t('chp.Pending')}}</div>
              <div :class="{'active':(refundType==2)}" @click="refundType=2">{{$t('base.completed')}}</div>
            </template>
          </div>
        </div>
        <template v-if="chpTab==0&&!isNull">
          <ul class="chp_list">
            <li class=" chp_gary">
              <div>{{ $t('base.title') }}</div>
              <div>{{ $t('base.type') }}</div>
              <div class="text_right">{{ $t('base.amount') }}</div>
              <div class="text_right">{{ $t('base.balance') }}</div>
              <div class="tetx_time">{{ $t('base.createTime') }}</div>
            </li>
            <li v-for='(item,index) in list' :key="index">
              <div class="line_txt1">{{item.Describe?item.Describe:''}}</div>
              <div>{{item.ConsumptionType!=2?$t('base.deduct'):$t('base.increase')}}</div>
              <div class="text_right" :class="item.ConsumptionType!=2?'text_red':'text_greed'">{{item.ConsumptionType!=2?'':'+'}}{{item.Money}}</div>
              <div class="text_right">{{item.SumMoney}}</div>
              <div class="tetx_time">{{item.CreateDate|setTime}}</div>
            </li>
          </ul>
        </template>
        <template v-if="noNew&&chpTab==1&&!isNull">
          <ul class="chp_list chp_refund" :class="{'refund_Pending':(refundType==1)}">
            <li class=" chp_gary">
              <div>PayPal</div>
              <div>CHP</div>
              <div>{{$t('base.RefundRequestDate')}}</div>
              <div v-if="refundType!=1">{{$t('base.RefundProcessedDate')}}</div>
              <div class="text_right">{{$t('base.status')}}</div>
            </li>
            <li v-for='(item,index) in list' :key="index" :class="{'chp_refund_item':(refundType!=1)}" @click="showRefundDetail(item)">
              <div class="line_txt1">{{item.PayPal}}</div>
              <div class="text_greed">{{item.RefundAmount}}</div>
              <div>{{item.CreateDate|setTime}}</div>
              <div v-if="refundType!=1">{{item.RefundDate|setTime}}</div>
              <div class="text_right">
              <!-- 退款状态（1:待处理, 2:已退款, 3:拒绝退款） -->
                <span v-if="item.Status==1">{{$t('chp.Pending')}}</span>
                <span v-if="item.Status==2">{{$t('base.Refunded')}}</span>
                <span class="text_red" v-if="item.Status==3">{{$t('enum.declined')}}</span>
              </div>
            </li>
          </ul>
        </template>
        <not-null class="notfind" title="" :text="$t('base.noData')" v-if="isNull"  />
      </div>
    </div>
    <list-pagination :TotalCount="TotalCount" :ps="ps" @ps='pageSize' @pi='pageIndex' />
  </div>
</template>
<script>
import { getInfo,getTime,setInfo,beijingToLocal } from "@/api/public";
import ListPagination from '@/components/listpagination'
import NotNull from "@/components/notnull.vue";
export default {
  name: 'chp',
  components: { ListPagination,NotNull },
  data() {
    return {
      userInfo:'',
      ps: 10, //pagesize
      pi: 1, //pageindex
      TotalCount: 0,
      list:'',
      chpTab:0,//0:chpHistory,1:RefundHistory
      refundType:1,//1:Pending,2:Completed

      refundForm:{
        chp:'',
        paypal:''
      },
      isRefund:false,
      noNew:true,
      isNull:false,
      rules:{
          chp: [
            { required: true, message: this.$t('chp.youwantreturn'), trigger: 'blur' },
            { validator: this.validateChp, trigger: 'blur' },
          ],
          paypal: [
            { required: true, message: this.$t('chp.yourPayPalaccount'), trigger: 'blur' },
          ]
        }
    }
  },
  filters: {
    setTime(val) {
      return beijingToLocal(val)
    }
  },
  watch: {
    'chpTab': {
      handler(val) {
        
        this.isNull=false
        if(val==0){
          this.Consumption()
        }
        if(val==1){
          this.refundList()
        }
        //this.getNationIcons()
      }
    },
    'refundType':{
      handler(val) {
        this.isNull=false
        if(this.chpTab==0) return
        this.refundList()
        //this.getNationIcons()
      }
    }
  },
  created() {
    this.userInfo=getInfo()
    this.Consumption()
    this.getUserDetail()
    this.getMemberCHP()
  },
  mounted() {},
  methods: {
    validateChp(_rule, value, callback) {
      if (value === '' || value === undefined || value === null) {
        callback(new Error(this.$t('chp.youwantreturn')));
      } else if (isNaN(value) || !/^\d+(\.\d+)?$/.test(value)) {
        callback(new Error('Please enter a valid number'));
      } else if (parseFloat(value) <= 0) {
        callback(new Error('The CHP amount must be greater than 0'));
      } else {
        callback();
      }
    },
    submitRefund(){
      const that=this
      const data={
        'memberid':that.userInfo.MappingUserId,
        'token':that.userInfo.ChineseToken,
        'operator_id':that.userInfo.MappingUserId,
        'RefundAmount':that.refundForm.chp,
        PayPal:that.refundForm.paypal,
        MemberSource:that.userInfo.MemberSource,
        RealName:that.userInfo.NickName
      }
      this.$refs['refundForm'].validate((valid) => {
          if (valid) {
            that.$post(this.$interface.AddRefundCHPInfo,data).then(res=>{
              if(res.Result){
                this.$message('Success')
                this.$refs['refundForm'].resetFields();
                this.isRefund=false
                that.pi=1
                this.getUserDetail()
                if(this.chpTab!=1){
                  this.chpTab=1
                }else{
                  this.refundList()
                }
              }else{
                this.$message.error(res.Msg)
              }
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
    },
    showRefund(val){
      const that=this
      if(!val){
        that.isRefund=val
        return
      }
      if(that.userInfo.IsRefund){
        that.isRefund=val
      }else{
        this.$alert(this.$t('chp.violations'), this.$t('base.hint'), {
          showConfirmButton:false
        });
      }
    },
    getMemberCHP(){
      const that=this
      const data={'memberid':that.userInfo.MappingUserId,'token':that.userInfo.ChineseToken,'operator_id':that.userInfo.MappingUserId}
      that.$get(this.$interface.GetMemberCHP,data).then(res=>{
        if(res.Result!=0){
          const data=res.Data;
          that.userInfo.SumMoney=data.SumMoney;
          that.userInfo.GiveCHP=data.GiveCHP;
          that.userInfo.IsRefund=data.IsRefund;
          that.userInfo.RefundCHP=data.RefundCHP;
          //that.userInfo.IsRefund=0;
          setInfo('SumMoney', data.SumMoney)
        }
      })
    },

    // 获取用户详情
    /**
     * 获取用户详细信息
     * 通过接口请求获取用户的积分和总金额等信息
     * @method getUserDetail
     * @description 调用 GetUserDetail 接口获取用户详情，并更新本地用户信息
     * @returns {Promise} 返回请求结果的 Promise
     */
    getUserDetail() {
      let that = this;
      let data={'memberid':that.userInfo.MappingUserId,'token':that.userInfo.ChineseToken,'operator_id':that.userInfo.MappingUserId}
      that.$get(this.$interface.GetUserDetail,data).then(res=>{
        if(res.result!=0){
          let data=res.data;
          that.userInfo.PointCount=data.PointCount;
          that.userInfo.SumMoney=data.SumMoney;
          setInfo('PointCount', data.PointCount)
          setInfo('SumMoney', data.SumMoney)
         // getUser(that.userInfo,0)
          // window.localStorage.setItem("cardUser", JSON.stringify(that.userInfo))
        }
      })
    },
    // 获取消费明细
    /**
     * 获取用户消费记录
     * @description 通过用户ID和token调用接口获取消费记录列表
     * @method Consumption
     * @returns {Promise} 返回消费记录数据列表
     * @property {Object} data - 请求参数
     * @property {String} data.memberid - 会员ID
     * @property {String} data.operator_id - 操作员ID
     * @property {String} data.token - 中文token
     * @property {Number} data.pageindex - 页码
     * @property {String} data.begindate - 开始日期
     * @property {String} data.enddate - 结束日期
     * @property {String} data.ConsumptionType - 消费类型
     */
    Consumption() {
      let that = this
      that.refundType=1
      let data={memberid:that.userInfo.MappingUserId,operator_id:that.userInfo.MappingUserId,token:that.userInfo.ChineseToken,PageIndex:that.pi,PageSize:that.ps,begindate:'',enddate:'',ConsumptionType:''}
      this.$get(this.$interface.Consumption,data).then(res=>{
        if(res.result!=0){
          that.TotalCount=res.count
          that.list=res.data
        }
        //console.log(res)
      })
    },
    refundList(){
      const that=this;
      let data={
        memberid:that.userInfo.MappingUserId,
        operator_id:that.userInfo.MappingUserId,
        token:that.userInfo.ChineseToken,
        PageIndex:that.pi,
        PageSize:that.ps,
        Status:that.refundType
      }
        that.TotalCount=0
      this.$get(this.$interface.GetRefundCHPList,data).then(res=>{
        if(res.Result!=0){
          that.TotalCount=res.Count
          that.list=res.Data
          if(res.Data&&res.Data.length<=0){
            that.isNull=true
          }
        }else{
          that.list=''
          that.isNull=true
        }
      })
      
      console.log(1231231231)
    },
    showRefundDetail(obj){
      if(this.refundType==1)return
      try{
        const h = this.$createElement
        const images = obj.VoucheImage.map(src =>
          h('el-image', {
            style: { height: '280px', marginRight: '10px' },
            attrs: { src: src, 'preview-src-list': obj.VoucheImage }
          })
        )
        const message = h('div', null, images)
        this.$alert(message, this.$t('base.hint'))
      }catch(e){
        console.log(e)
      }
    },
    // 
    pageSize(val) {
      this.ps = val

      
      if(this.chpTab==0){
          this.Consumption()
        }
        if(this.chpTab==1){
          this.refundList()
        }
    },
    // 页码
    pageIndex(val) {
      this.pi = val
      if(this.chpTab==0){
          this.Consumption()
        }
        if(this.chpTab==1){
          this.refundList()
        }
    },
  }
}

</script>
<style scoped>
.thousand_layout{
  width: auto;
}
.What_c{
  display: flex;
}
.What_c span{
  width: 16px;
  height: 16px;
  background: url(../../../static/images/icon_doubt.svg) no-repeat;
  margin: 0 4px 0 0;
}
.chp_box {
  padding: 20px 0;
}

.chp_index {
  height: 177px;
  min-width: 320px;
  display: inline-block;
  background: linear-gradient(to bottom right, RGBA(139, 154, 223, 1), RGBA(96, 110, 175, 1));
  border-radius: 5px;
  overflow: hidden;
}

.chp_index_box {
  background: url(../../../static/images/Frame.svg) right bottom no-repeat;
  width: 100%;
  height: 100%;
  color: #fff;
  padding: 16px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-size: 16px;
}

.chp_index_box:before {
  content: "";
  background: url(../../../static/images/icon/icon_CHP.svg) no-repeat;
  width: 40px;
  height: 40px;
  top: 16px;
  right: 16px;
  position: absolute;
}

.chp_num {
  font-size: 48px;
  font-weight: bold;
}

.chp_change {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.chp_change a {
  color: #fff;
  font-size: 14px;
}

.chp_btn {
  min-width: 46px;
  padding: 10px 20px;
  border: 1px solid #fff;
  border-radius: 4px;
  display: inline-block;
  line-height: 1;
  font-size: 14px;
  margin-right: 10px;
  cursor: pointer;
}

.chp_list_box {
  overflow: hidden;
}

.chp_h4 {
  font-size: 24px;
  margin-top: 40px;
  margin-bottom: 20px
}



.chp_list>li{
  display: grid;
  grid-template-columns: 36% 10% 10% 10% auto;
  border-bottom: 1px solid #e0e0e0;
  gap: 2%;
}
.chp_list>li>div{
  margin:12px;

}
.text_right{
  text-align: right;
}

.chp_gary{
  background-color: #f7f7f7;
}
.chp_list .tetx_time{
  padding-left: 52px;
}
.chp_refund>li{
  grid-template-columns: 23% 11% 19% 19% auto;
  align-items: center;
}

.refund_Pending>li{
  grid-template-columns: 32% 19% 23% auto;
  align-items: center;
}

.chp_tab{
  border-bottom: 1px solid #C8C8C8;
  display: flex;
}
.chp_tab>div{
  border: 1px solid #C8C8C8;
  border-bottom: none;
  padding: 10px 20px;
  line-height: 1.5;
  font-size: 16px;
  cursor: pointer;
}
.chp_tab .active{
  color: #fff;
  background-color: #5F6DAE;
}
.refund_tab{
  margin: 18px auto 10px;
  display: flex;
}
.refund_tab div{
  padding: 10px 12px;
  font-size: 14px;
  color: #a0a0a0;
  background-color: #f7f7f7;
  border:1px solid #f7f7f7;
  border-radius: 4px;
  cursor: pointer;
}
.refund_tab div.active{
  border-color: #5F6DAE;
  color: #5F6DAE;
  background-color: #fff;
}
.refund_tab div+div{
  margin-left: 10px;
}
.refundDialogBox{
  margin: 0 auto;
  width: 92%
}
.Refundable{
  display: flex;
  margin: 12px auto;
  align-items: center;
}
.Refundable::before{
  content: '';
  background: url(../../../static/images/icon/icon_CHP.svg) no-repeat;
  width: 40px;
  height: 40px;
  display: block;
  margin-right: 24px;
}
.refundableCHP{
  flex: 1;
  line-height: 1.5;
}
.refundableCHP .chp{
  font-size: 16px;
  font-weight: 700;
  display: flex;
  align-items: center;
}
.refundableCHP .chp span{
  font-size: 24px;
  margin-left: 4px;
}
.alert_divider{
  margin: 14px 0;
  border-top: 1px solid #e0e0e0;
}
.chp_refund_item{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/user/chp.vue